/* eslint-disable no-shadow */
import { make } from 'vuex-pathify';
import axios from 'axios';

export const USER_TOKEN_KEY = 'user-token';
export const USER_DATA = 'user-data';

const getUserData = () => {
  const userData = localStorage.getItem(USER_DATA);
  if (!userData) return undefined;

  return JSON.parse(userData) || undefined;
};

const getDefaultState = () => ({
  token: localStorage.getItem(USER_TOKEN_KEY) || undefined,
  user: getUserData() || undefined,
  status: undefined,
  loading: false,
  language: undefined,
  authsuccess: undefined,
});

const state = () => getDefaultState();

export const getters = {
  isAuthenticated: state => !!state.token && !!state.user,

  authStatus: state => state.status,

  getUser: state => () => state.user,

  getLogin: state => () => state.authsuccess,
};

const mutations = {
  ...make.mutations(state),

  AUTH_REQUEST(state) {
    state.status = 'loading';
  },
  AUTH_SUCCESS(state, { token, user }) {
    state.status = 'success';
    state.token = token;
    state.user = user;
  },
  AUTH_ERROR(state) {
    state.status = 'error';
  },

  AUTH_LOGOUT(state) {
    state.token = undefined;
    state.user = undefined;
  },

  SET_USER(state, user) {
    state.user = user;
    localStorage.setItem(USER_DATA, JSON.stringify(user));
  },

  SET_TOKEN(state, token) {
    state.token = token;
    localStorage.setItem(USER_TOKEN_KEY, token);
  },

  PURGE_DATA(state) {
    state.authsuccess = false;
  },
};

export const actions = {
  async SSO({ commit }, token) {
    try {
      commit('SET_LOADING', true);

      const { data, error } = await axios.post('/login', { token });
      if (!error) {
        const { token, user } = data;
        commit('AUTHSUCCESS', data);

        commit('SET_TOKEN', token);
        commit('SET_USER', user);

        axios.defaults.headers.common.Authorization = `Bearer ${token}`;

        window.Vue.$router.push({ name: 'Home' });
      } else throw new Error(data);
    } catch (e) {
      commit('AUTH_ERROR', e);
      // window.Vue.$toast.error(e.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },


  async login({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', true);

      axios
        .post('/login', payload)
        .then((response) => {
          localStorage.setItem(USER_TOKEN_KEY, response.token);

          commit('AUTH_SUCCESS', true);
          commit('SET_TOKEN', response.data.token);
          commit('SET_USER', response.data.user);

          axios.defaults.headers = {
            Authorization: `Bearer ${response.token}`,
          };
          resolve(response.data);
        })
        .catch((err) => {
          localStorage.removeItem(USER_TOKEN_KEY);
          reject(err);
        });
    });
  },

  // async login2({ commit }, { email, password }) {
  //   let userInfo;
  //   try {
  //     commit('SET_LOADING', true);

  //     const { data, error } = await axios
  //       .post('/login', { email, password })
  //       .then((response) => {
  //
  //         if (!error) {
  //           const { token, user } = response.data;
  //           commit('AUTH_SUCCESS', data);
  //           commit('SET_TOKEN', token);
  //           commit('SET_USER', user);
  //
  //           localStorage.setItem(USER_TOKEN_KEY, token);
  //           // dispatch('localeModule/changeLocale', user.locale, { root: true });

  //           axios.defaults.headers.common.Authorization = `Bearer ${token}`;

  //           // window.Vue.$router.push({ name: 'Home' });
  //         } else throw new Error(data);
  //       });
  //     userInfo = data;
  //     return userInfo;

  //
  //   } catch (e) {
  //     commit('AUTH_ERROR', e);

  //     localStorage.removeItem(USER_TOKEN_KEY);
  //     localStorage.removeItem(USER_DATA);

  //     // window.Vue.$toast.error(e.message);
  //   } finally {
  //     commit('SET_LOADING', false);
  //   }
  // },


  async register({ commit }, requestData) {
    try {
      commit('SET_LOADING', true);

      const { data, error } = await axios.post('/newArtist', requestData);
      if (!error) {
        window.Vue.$toast.success(data);
      } else throw new Error(data);
    } catch (e) {
      window.Vue.$toast.error(e.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async newDiscipline({ commit }, requestData) {
    try {
      commit('SET_LOADING', true);

      const { data, error } = await axios.post('/newPanel', requestData);
      if (!error) {
        window.Vue.$toast.success(data);
      } else throw new Error(data);
    } catch (e) {
      window.Vue.$toast.error(e.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async postDiscipline({ commit }, formData) {
    try {
      commit('SET_LOADING', true);
      const { data } = await axios.post('/newPanel', formData);
      commit('SET_PANEL', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async passwordRecover({ commit }, { email }) {
    try {
      commit('SET_LOADING', true);

      const { data, error } = await axios.post('/user/password/recover', { email });
      if (!error) {
        window.Vue.$toast.success('Se ha enviado un correo para poder continuar con la validación');
      } else throw new Error(data);
    } catch (e) {
      window.Vue.$toast.error(e.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async logout({ commit }) {
    try {
      commit('SET_LOADING', true);
      const { data, error } = await axios.post('/logout');
      if (!error) {
        commit('AUTH_LOGOUT');
        localStorage.removeItem(USER_TOKEN_KEY);
        localStorage.removeItem(USER_DATA);
        commit('PURGE_DATA');
        // delete axios.defaults.headers.common.Authorization;
        window.Vue.$router.push('/');
      } else throw new Error(data);
    } catch (e) {
      window.Vue.$toast.error(e.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  reloadUserPoints({ commit }, points) {
    const user = getUserData();
    user.points = points;

    commit('SET_USER', user);
  },

  async changeAvatar({ state, commit }, { newAvatar, typeAvatar, dataAvatar }) {
    try {
      const nameFile = Date.now();
      const formData = new FormData();
      if (typeAvatar === 'avatarGenerate') {
        formData.append('userAvatar', newAvatar, `${nameFile}.png`);
        formData.append('dataAvatar', dataAvatar);
      } else if (typeAvatar === 'imageUpload') {
        formData.append('userAvatar', newAvatar);
      }

      const { error, data } = await axios.post('/change-avatar', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (!error) {
        const user = Object.assign(state.user, { avatar: data.avatar, dataAvatar });
        commit('SET_USER', user);

        window.Vue.$toast.success(data.message);
      } else throw new Error(data);
    } catch (e) {
      window.Vue.$toast.error(e.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // async changePassword({ commit }, { actualPassword, newPassword }) {
  //   try {
  //     const { error, data } = await axios.post('/change-password', { actualPassword, newPassword });
  //     if (!error) {
  //       window.Vue.$toast.success(data);
  //     } else throw new Error(data);
  //   } catch (e) {
  //     window.Vue.$toast.error(e.message);
  //   } finally {
  //     commit('SET_LOADING', false);
  //   }
  // },

  async checkPassword({ commit }, { passCode }) {
    try {
      const { error, data } = await axios.post('/user/password/check', { passCode });
      if (!error) {
        window.Vue.$toast.success(data);
      } else throw new Error(data);
    } catch (e) {
      window.Vue.$toast.error(e.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async newPassword({ commit }, { newPassword }) {
    try {
      const { error, data } = await axios.post('/user/password/update', { newPassword });
      if (!error) {
        window.Vue.$toast.success(data);
      } else throw new Error(data);
    } catch (e) {
      window.Vue.$toast.error(e.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async changeInformationUser({ state, commit, dispatch }, user) {
    try {
      const { data, error } = await axios.post('/change-information-user', user);
      if (!error) {
        const user = Object.assign(state.user, {
          firstName: data.user.firstName,
          lastName: data.user.lastName,
          locale: data.user.locale,
        });
        commit('SET_USER', user);

        dispatch('localeModule/changeLocale', user.locale, { root: true });

        window.Vue.$toast.success(data.message);
      } else throw new Error(data);
    } catch (e) {
      window.Vue.$toast.error(e.message);
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
